import styled from "styled-components";

export const AppLogoWrapper = styled.div`
  font-size: 24px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  user-select: none;
  display: flex;
  img {
    width: 300px;
    opacity: 0;
  }
  @media screen and (max-width: 768px) {
    img {
      width: 120px;
    }
  }
`;
